import { APP_INITIALIZER, Inject, Injectable } from '@angular/core';
import { NavigationRegions } from '@trustedshops/tswp-carrier-employees-contracts';
import { BootstrapperBase } from '@trustedshops/tswp-core-common';
import {
  NavigationEntries,
  Routes,
} from '@trustedshops/tswp-plugin-settings-contracts';
import { TOKENS, PluginRouter } from '@trustedshops/tswp-core-plugins';
import {
  NavigationItem,
  NavigationService,
  TOKENS as TOKENS_UI,
  UserInteractionType,
} from '@trustedshops/tswp-core-ui';

@Injectable()
export class SettingsBootstrapper implements BootstrapperBase {
  //#region Public Constants
  public static readonly TYPE: string =
    '@trustedshops/tswp-carrier-employees:SettingsBootstrapper';
  //#endregion

  //#region Ctor
  public constructor(
    @Inject(TOKENS.PluginRouter)
    private readonly _pluginRouter: PluginRouter,

    @Inject(TOKENS_UI.NavigationService)
    private readonly _navigationService: NavigationService
  ) {}
  //#endregion

  //#region Public Methods
  public async initialize(): Promise<void> {
    this.registerRoute();
    this.registerNavigationItem();
  }
  //#endregion

  //#region Private Methods
  private registerRoute(): void {
    // No parent id: root-level 'settings' route, matching the old plugin's
    // own registerRoutes() call. No `plugin` field: that triggers
    // PluginLoadedRouteGuard, meant for the legacy dynamically-loaded
    // plugin system — irrelevant to native carrier code.
    this._pluginRouter.addRoutes([
      {
        id: Routes.Settings,
        webComponent: 'tswp-route-content',
        path: 'settings',
      },
    ]);
  }

  private registerNavigationItem(): void {
    const navigationItem = {
      id: NavigationEntries.Settings,
      label: 'Settings',
      order: 1000,
      icon: 'helios-icon helios-icon-feature-navigation-settings',
      userInteraction: this._navigationService
        .getUserInteractionFactory(UserInteractionType.NavigateToFirstChild)
        .create({
          parentNavigationItemId: NavigationEntries.Settings,
          childrenRegion: NavigationRegions.SecondaryMenu,
        }),
    } as unknown as NavigationItem;

    this._navigationService.registerNavigationItems(
      [navigationItem],
      NavigationRegions.PrimaryMenu
    );
  }
  //#endregion
}

export const SettingsInitializer = [
  SettingsBootstrapper,
  {
    provide: APP_INITIALIZER,
    multi: true,
    useFactory: (initializer: SettingsBootstrapper) => {
      return () => initializer.initialize();
    },
    deps: [SettingsBootstrapper],
  },
];
